<script>
    import FormTableBaseElement from "./FormTableBaseElement";

    export default {
        name: "FormTableBaseText",
        extends: FormTableBaseElement,
    }
</script>